package com.dotdrives.web.pages.settings

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

val SettingsNavigationStyles = FC<Props> { style { +"""
.settings-section-picker,.process-mobile-picker { display:none; }
@media(max-width:700px) {
  .settings-page .settings-tabs,.process-configuration .process-navigation { display:none; }
  .settings-section-picker,.process-mobile-picker { display:grid;gap:8px;min-width:0; }
  .settings-section-picker { margin-bottom:24px; }
  .settings-section-picker label,.process-mobile-picker label { font-weight:800;font-size:14px; }
  .settings-section-picker select,.process-mobile-picker select { width:100%;min-width:0;min-height:46px;padding:10px 12px;border:1px solid #B7C0C7;border-radius:10px;background:white;font:inherit;color:#222D32; }
  .process-configuration .process-layout { grid-template-columns:minmax(0,1fr); }
  .process-editor-footer { position:sticky;bottom:76px;z-index:2; }
}
""" } }
